import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropertyFilters from "@/components/PropertyFilters";
import { useLocations } from "@/hooks/useLocations";
import { defaultPropertySearchFilters, filtersToSearchParams, type PropertySearchFilters } from "@/lib/propertyFilters";

const HeroSection = () => {
  const navigate = useNavigate();
  const { data: locations = [], isLoading: loadingLocations } = useLocations();
  const [filters, setFilters] = useState<PropertySearchFilters>(defaultPropertySearchFilters);

  return (
    <section className="relative min-h-screen flex flex-col justify-center">
      {/* Video background */}
      <div className="absolute inset-0 overflow-hidden bg-primary">
        <iframe
          src="https://www.youtube.com/embed/u1PBd4ITAz4?autoplay=1&mute=1&loop=1&playlist=u1PBd4ITAz4,uNwqh6LbMuc&controls=0&showinfo=0&modestbranding=1&rel=0"
          className="pointer-events-none absolute left-1/2 top-1/2 h-[56.25vw] min-h-full w-[177.78vh] min-w-full -translate-x-1/2 -translate-y-1/2"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          title="Luxury Real Estate Background"
        />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,24,14,0.35)_0%,rgba(26,63,34,0.58)_42%,rgba(10,24,14,0.92)_100%)]" />
      </div>

      {/* Content */}
        <div className="relative z-10 w-full px-6 md:px-16 text-center flex flex-col items-center pt-40 md:pt-44">
        <div className="animate-fade-up" style={{ animationDelay: "0.2s", opacity: 0 }}>
          {/* Main Name */}
          <h1 className="font-montserrat font-semibold text-4xl md:text-6xl lg:text-8xl uppercase tracking-[0.15em] text-metallic-tan leading-tight" style={{
            textShadow: '3px 3px 0px rgba(0,0,0,0.3), 6px 6px 0px rgba(0,0,0,0.2), 9px 9px 0px rgba(0,0,0,0.1)',
            transform: 'perspective(500px) rotateX(5deg)',
            transformStyle: 'preserve-3d'
          }}>
            WILD GATES
          </h1>
          
          {/* Descriptor */}
          <div className="font-montserrat font-light text-3xl md:text-3xl lg:text-4xl uppercase tracking-[0.1em] text-metallic-tan mt-2" style={{
            textShadow: '3px 3px 0px rgba(0,0,0,0.3), 6px 6px 0px rgba(0,0,0,0.2)',
            transform: 'perspective(500px) rotateX(3deg)',
            transformStyle: 'preserve-3d'
          }}>
            Real Estate
          </div>
          
          {/* Separator */}
          <div className="relative my-6">
            <div className="h-px w-32 md:w-40 lg:w-48 bg-white mx-auto" style={{
              boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}></div>
          </div>
          
          {/* Tagline */}
          <div className="font-montserrat font-light italic text-xl md:text-xl lg:text-2xl lowercase text-dusty-rose" style={{
            textShadow: '2px 2px 0px rgba(0,0,0,0.3), 4px 4px 0px rgba(0,0,0,0.2)',
            transform: 'perspective(500px) rotateX(2deg)',
            transformStyle: 'preserve-3d'
          }}>
            curated luxury
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
